import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { Pagination } from '@app/shared/models/pagination';
import { SubscriptionDetails } from '@app/shared/models/subscription-details';
import { OwnerUsers, User } from '../../shared/models/user';
import { SubscriptionType } from '../../shared/models/subscription-type';
import { CreditsInfo } from '@app/shared/models/credits-info';
import { MaxCredits } from '@app/shared/models/max-credits';

export const loadUserProfile = createAction('[Users] load user profile');

export const loadUserProfileSuccess = createAction(
  '[Users] load user profile success',
  props<{ payload: { user: User } }>(),
);

export const loadUserProfileError = createAction(
  '[Users] load user profile error',
  props<{ error: HttpErrorResponse }>(),
);

export const loadUsers = createAction(
  '[User management] Load Users',
  props<{ search?: string; page?: number }>(),
);

export const loadUsersSuccess = createAction(
  '[User management] Load Users Success',
  props<{ usersPagination: Pagination<User> }>(),
);

/* eslint-disable @typescript-eslint/no-explicit-any */
export const loadUsersError = createAction(
  '[User management] Load Users Error',
  props<{ error: any }>(),
);

export const loadUsersByIds = createAction(
  '[User management] Load Users by Ids',
  props<{ userIds: number[] }>(),
);

export const updateFirstAndLastNames = createAction(
  '[Users] update first and last names',
  props<{ payload: { firstName: string; lastName: string } }>(),
);

export const changePassword = createAction(
  '[Users] change password',
  props<{ payload: { newPassword: string; currentPassword: string } }>(),
);

export const changePasswordSuccess = createAction('[Users] change password success');

export const changePasswordError = createAction(
  '[Users] change password error',
  props<{ error: HttpErrorResponse }>(),
);

export const changeConnectedToGraph = createAction(
  '[Users] Change connected to graph',
  props<{ connectedToGraph: boolean; userId: number }>(),
);

export const connectedToGraphSuccess = createAction(
  '[Users] Change connected to graph Success',
  props<{ connectedToGraph: boolean }>(),
);

export const changeConnectedToGmail = createAction(
  '[Users] Change connected to gmail',
  props<{ connectedToGmail: boolean; userId: number }>(),
);

export const connectedToGmailSuccess = createAction(
  '[Users] Change connected to gmail Success',
  props<{ connectedToGmail: boolean }>(),
);

export const downloadSignature = createAction('[Users] Download Signature');

export const downloadSignatureSuccess = createAction(
  '[Users] Download Signature Success',
  props<{ signature: string }>(),
);

export const downloadSignatureError = createAction(
  '[Users] Download Signature Error',
  props<{ error: object }>(),
);

export const loadUserSubscriptionType = createAction('[Users] load user subscription type');

export const loadUserSubscriptionTypeSuccess = createAction(
  '[Users] load user subscription type success',
  props<{ payload: { subscriptionType: SubscriptionType } }>(),
);

export const loadUserSubscriptionTypeError = createAction(
  '[Users] load user subscription type error',
  props<{ error: HttpErrorResponse }>(),
);

export const loadUserSubscriptionDetails = createAction('[Users] load user subscription details');

export const loadUserSubscriptionDetailsSuccess = createAction(
  '[Users] load user subscription details success',
  props<{ payload: { subscriptionDetails: SubscriptionDetails } }>(),
);

export const loadUserSubscriptionDetailsError = createAction(
  '[Users] load user subscription details error',
  props<{ error: HttpErrorResponse }>(),
);

export const setTrialDaysLeft = createAction(
  '[Users] set trial days left',
  props<{ trialDaysLeft: number | null }>(),
);

export const setIsUserOnPricingPage = createAction(
  '[Users] set is user on pricing page',
  props<{ isUserOnPricingPage: boolean }>(),
);

export const manageBilling = createAction(
  '[Users] manage billing',
  props<{ updateSubscription: boolean }>(),
);

export const createUnpaidInvoicePaymentLink = createAction(
  '[Users] create unpaid invoice payment link',
);

export const createUnpaidInvoicePaymentLinkError = createAction(
  '[Users] create unpaid invoice payment link error',
  props<{ error: HttpErrorResponse }>(),
);

export const loadTrialDurationInDays = createAction('[Subscriptions] load trial duration in days');

export const loadTrialDurationInDaysSuccess = createAction(
  '[Subscriptions] load trial duration in days success',
  props<{ payload: { trialDurationInDays: number } }>(),
);
export const loadTrialDurationInDaysError = createAction(
  '[Subscriptions] load trial duration in days error',
  props<{ error: HttpErrorResponse }>(),
);

export const loadCreditsLimitations = createAction('[Users] Load credits limitations');

export const loadCreditsLimitationsSuccess = createAction(
  '[Users] Load credits limitations Success',
  props<{ payload: { creditsLimitations: CreditsInfo | null } }>(),
);
export const loadCreditsLimitationsError = createAction(
  '[Users] Load credits limitations Error',
  props<{ error: HttpErrorResponse }>(),
);

export const loadCreditsMaxLimit = createAction('[Users] Load credits max limit');

export const loadCreditsMaxLimitSuccess = createAction(
  '[Users] Load credits max limit Success',
  props<{ payload: { creditsMaxLimit: MaxCredits } }>(),
);
export const loadCreditsMaxLimitError = createAction(
  '[Users] Load credits max limit Error',
  props<{ error: HttpErrorResponse }>(),
);

export const loadUsersForAdmin = createAction('[Users] load users for admin');

export const loadUsersForAdminSuccess = createAction(
  '[Users] load users for admin success',
  props<{ payload: { users: OwnerUsers } }>(),
);

export const loadUsersForAdminError = createAction(
  '[Users] load users for admin Error',
  props<{ error: HttpErrorResponse }>(),
);
